import type { PropositionDocumentType } from "@dune/types";
import {
	propositionDocumentTypeEnum,
	propositionDocumentTypeLabels,
} from "@dune/types";
import React from "react";
import UploadDocumentModal, {
	type DocumentTypeOption,
} from "../../../../component/common/UploadDocumentModal";
import { useUploadPropositionDocument } from "../../../../api/mutations/propositions.mutations";

interface UploadDocumentModalProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	propositionId: number;
}

const PropositionUploadDocumentModal: React.FC<UploadDocumentModalProps> = ({
	open,
	onOpenChange,
	propositionId,
}) => {
	const uploadDocument = useUploadPropositionDocument();

	const documentTypeOptions: DocumentTypeOption[] = Object.values(
		propositionDocumentTypeEnum,
	).map((value) => ({
		value,
		label: propositionDocumentTypeLabels[value],
	}));

	const handleUpload = async (params: {
		fileId?: string;
		documentType: string;
	}) => {
		if (!params.fileId) {
			throw new Error("File ID is required");
		}

		await uploadDocument.mutateAsync({
			propositionId,
			fileId: params.fileId,
			type: params.documentType as PropositionDocumentType,
		});
	};

	return (
		<UploadDocumentModal
			open={open}
			onOpenChange={onOpenChange}
			documentTypeOptions={documentTypeOptions}
			onUpload={handleUpload}
			isPending={uploadDocument.isPending}
			requiresFileRegistration={true}
		/>
	);
};

export default PropositionUploadDocumentModal;
